import { Handler, addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { CartResult, GetCartApiParameter } from "@insite/client-framework/Services/CartService";
import {
    chain,
    DispatchBeginLoadCart,
    PopulateApiParameter,
    DispatchCompleteLoadCart,
} from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import { HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";

export interface LoadCartApiInterface {
    cartId: string;
    shouldLoadFullCart?: boolean;
    showLoad?: boolean;
    loading?: boolean;
}

type HandlerType = Handler<
    | LoadCartApiInterface
    | ({
          apiParameter: GetCartApiParameter;
      } & HasOnSuccess),
    | {
          apiParameter: GetCartApiParameter;
          apiResult: CartResult;
          needFullCart: boolean;
      }
    | any
>;

export const DispatchBeginLoadCartCustom: HandlerType = props => {
    const flag = "showLoad" in props.parameter ? props.parameter.showLoad : true;
    if (flag) {
        props.dispatch({
            type: "Data/Carts/BeginLoadCart",
            id: "cartId" in props.parameter ? props.parameter.cartId : props.parameter.apiParameter.cartId,
        });
    }
};

export const PopulateApiParameterCustom: HandlerType = props => {
    if ("apiParameter" in props.parameter) {
        props.apiParameter = props.parameter.apiParameter;
        return;
    }

    props.apiParameter = {
        cartId: props.parameter.cartId,
        expand: ["validation"],
    };

    if (props.needFullCart) {
        if (props.parameter.loading !== false) {
            props.apiParameter.forceRecalculation = true;
            props.apiParameter.allowInvalidAddress = true;
        }
        props.apiParameter.expand = [
            ...(props.apiParameter.expand || []),
            "cartLines",
            "restrictions",
            "shipping",
            "tax",
            "carriers",
            "paymentOptions",
            "creditCardBillingAddress",
        ];
    }
};

export const EnablePlaceOrderButton: HandlerType = props => {
    setTimeout(() => {
        props.dispatch({ type: "Custom/DeliveryMethodChanges/CompleteLoading", result: false });
    }, 2000);
};

replaceInChain(chain, DispatchBeginLoadCart, DispatchBeginLoadCartCustom);
replaceInChain(chain, PopulateApiParameter, PopulateApiParameterCustom);
addToChainAfter(chain, DispatchCompleteLoadCart, EnablePlaceOrderButton);
